import type { ReactElement } from "react";

import type { OnboardingDescriptionDto } from "app/pages/sales-intelligence/sub-modules/onboarding/types/OnboardingDescription.dto";
import WizardFocusCard from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/components/WizardCards/WizardFocusCard";
import WizardContentWrapper from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/components/WizardContentWrapper/WizardContentWrapper";
import {
    StyledAnimatedWizardFocusCard,
    StyledWizardFocusCardsContainer,
} from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/containers/styles";
import {
    WIZARD_ANIMATION_DELAY,
    WIZARD_ANIMATION_TIME,
} from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/styles";
import type { OnboardingFocusQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";

interface Props {
    isValid: boolean;
    isLoading?: boolean;
    cardItems: OnboardingDescriptionDto;
    activeCards: Record<OnboardingFocusQuestionType, boolean>;
    onCardClick: (cardType: OnboardingFocusQuestionType) => void;
    onNext: () => void;
}

const WizardFocusQuestionsContainer = ({
    isValid,
    isLoading,
    cardItems,
    activeCards,
    onCardClick,
    onNext,
}: Props): ReactElement => {
    const cards = cardItems.map(({ userGoal }, index) => (
        <StyledAnimatedWizardFocusCard
            key={userGoal}
            delay={(index + 1) * WIZARD_ANIMATION_TIME + WIZARD_ANIMATION_DELAY}
        >
            <WizardFocusCard
                key={userGoal}
                type={userGoal}
                isActive={activeCards[userGoal]}
                onClick={() => onCardClick(userGoal)}
            />
        </StyledAnimatedWizardFocusCard>
    ));

    return (
        <WizardContentWrapper
            questionTitleKey="si.onboarding.wizard.question1.title"
            questionDescriptionKey="si.onboarding.wizard.question1.description"
            pageCount={2}
            currentPage={1}
            animatedChildren={cardItems.length}
            isNextDisabled={!isValid}
            isLoading={isLoading}
            onNext={onNext}
        >
            <StyledWizardFocusCardsContainer>{cards}</StyledWizardFocusCardsContainer>
        </WizardContentWrapper>
    );
};

export default WizardFocusQuestionsContainer;
